import React, { useContext } from 'react';
import './Works.css';
import Upwork from '../../img/Upwork.png';
import Fiverr from '../../img/fiverr.png';
import Pillar from '../../img/3pillar-logo.svg';
import AKC from '../../img/akc-logo.png';
import arche from '../../img/arche.png';
import { themeContext } from '../../Context';
import { Link } from 'react-scroll';

const Works = () => {

  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="works">
      {/* left side */}
      <div className="awesome">
        <span style={{color: darkMode ? 'white' : ''}}>Works for All these</span>
        <span>Brands & Clients</span>
        <span>
          Experience across freelance platforms, US clients, product teams,
          <br/>American Kennel Club contractor work, 3Pillar Global
          <br/>and Arche Software collaborations.
        </span>
        <Link spy={true} to={'Contact'} smooth={true}>
          <button className="button s-button">Hire me</button>
        </Link>
        
        <div className="blur s-blur1" style={{background: "#ABF1FF94"}}></div>
      </div>

      {/* Right side */}
      <div 

          className="w-right"
      
      >
        <div className="brand-panel" style={{background: darkMode ? "#111827" : ''}}>
          <div className="brand-copy">
            <span>Trusted work across teams, platforms and client environments.</span>
          </div>
          <div className="brand-grid">
          <div className="w-secCircle" style={{background: darkMode ? "#1f2937" : ''}}>
            <img src={Upwork} alt="" />
          </div>
          <div className="w-secCircle" style={{background: darkMode ? "#1f2937" : ''}}>
            <img src={Fiverr} alt="" />
          </div>
          <div className="w-secCircle pillar-logo" style={{background: darkMode ? "#1f2937" : '#111827'}}>
            <img src={Pillar} alt="" />
          </div>
          <div className="w-secCircle" style={{background: darkMode ? "#1f2937" : ''}}>
            <img src={AKC} alt="" />
          </div>
          <div className="w-secCircle" style={{background: darkMode ? "#1f2937" : ''}}>
            <img src={arche} alt="" />
          </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Works
